// 通用 icon 组件

const DEFAULT_SIZE = 16;
/**
 * 右箭头图标
 * @param color - 箭头颜色
 * @returns
 */
export function RightArrowIcon({ color = 'black', size = DEFAULT_SIZE }: { color?: string; size?: number }) {
    return (
        <svg width='100%' height='100%' viewBox={`0 0 ${size} ${size}`} fill='none'>
            <path d='M6 4L10 8L6 12' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}

export function LeftArrowIcon({ color = 'black', size = DEFAULT_SIZE }: { color?: string; size?: number }) {
    return (
        <svg width='100%' height='100%' viewBox={`0 0 ${size} ${size}`} fill='none'>
            <path d='M14 18L8 12L14 6' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}

/** 删除 / 清空历史记录 */
export function DeleteIcon({ color = '#B5B5B5' }: { color?: string }) {
    return (
        <svg width='100%' height='100%' viewBox='0 0 16 16' fill='none'>
            <path
                d='M3.5 5h9M4.5 5l.64 7.04c.09 1 .88 1.71 1.88 1.71h.96c1 0 1.79-.71 1.88-1.71L11.5 5M6.5 5V3.75c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5V5'
                stroke={color}
                strokeWidth='1.2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
